import { difference, intersection, union } from 'lodash';

import { SelectorItems } from '../components/CampaignAndGroupSelector/Selector/Selector';
import { selectAddableGroupTypes, selectEditableGroupTypes } from '../selectors/groupEdit/group/group';
import { AccessRights } from '../typings/common';
import { GdCampaignTypeInput, OperatorFeaturesFragment } from '../typings/graphql-grid';
import { CampaignAndGroupSelectorEntityToSelectType } from '../typings/sidebar';
import { ClientFeatures } from '../typings/state';

import { GroupsHelpers } from './GroupsHelpers/GroupsHelpers';

interface AccessRightsForCampaignAndGroupParams {
    operatorFeatures: OperatorFeaturesFragment;
    clientFeatures?: ClientFeatures;
    accessRights: AccessRights;
    type?: CampaignAndGroupSelectorEntityToSelectType;
    campaign?: SelectorItems;
    group?: SelectorItems;
}

interface AccessRightsForCampaignAndGroup {
    canAddInDna: boolean;
    canAddInDnaOnly: boolean;
    fullyAvailable: boolean;
}

export function getAccessRightsForCampaignAndGroupSelector(
    params: AccessRightsForCampaignAndGroupParams
): AccessRightsForCampaignAndGroup {
    const { operatorFeatures, clientFeatures, accessRights, type, campaign, group } = params;

    const addableGroupTypes = selectAddableGroupTypes(operatorFeatures, accessRights);
    const fullyAvailableGroupTypes = GroupsHelpers.getFullyAvailableGroupTypes();
    const fullyAvailableCampaignTypesForBannerCreation = GroupsHelpers.getFullyAvailableCampaignTypesForBannerCreation();
    const editableGroupTypes = selectEditableGroupTypes({ operatorFeatures, clientFeatures, accessRights });

    let canAddInDna = false;
    let fullyAvailable = false;

    switch (type) {
        case CampaignAndGroupSelectorEntityToSelectType.BANNER:
            canAddInDna = Boolean(group && group.groupType && editableGroupTypes.has(group.groupType));

            fullyAvailable =
                canAddInDna &&
                Boolean(campaign && fullyAvailableCampaignTypesForBannerCreation.includes(campaign.type));

            break;
        case CampaignAndGroupSelectorEntityToSelectType.GROUP:
            canAddInDna = Boolean(campaign && addableGroupTypes.includes(campaign.type));

            fullyAvailable = canAddInDna && Boolean(campaign && fullyAvailableGroupTypes.includes(campaign.type));

            break;
        default:
            break;
    }
    const canAddInDnaOnly = canAddInDna && Boolean(accessRights.canEditInternalAds);

    return {
        canAddInDna,
        canAddInDnaOnly,
        fullyAvailable
    };
}

export const getCampaignAndGroupSelectorAvailableCampaignTypes = (
    entityToSelectType?: CampaignAndGroupSelectorEntityToSelectType
): Array<GdCampaignTypeInput> => {
    const whitelist: Array<GdCampaignTypeInput> = []; // сейчас заполняется только blacklist, но в свиче можно и по
    // whitelist задавать типы кампаний
    let blacklist: Array<GdCampaignTypeInput> = [];

    switch (entityToSelectType) {
        case CampaignAndGroupSelectorEntityToSelectType.PHRASE_BETA:
        case CampaignAndGroupSelectorEntityToSelectType.PHRASE:
            blacklist = [GdCampaignTypeInput.DYNAMIC, GdCampaignTypeInput.PERFORMANCE];
            break;
        default:
            break;
    }

    const values = Object.keys(GdCampaignTypeInput).map(k => GdCampaignTypeInput[k]);

    return union(difference(values, blacklist), intersection(values, whitelist));
};
